import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useParams, useNavigate, Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_position_entry_hire = () => {
  useAuthRedirect();
  const { sno } = useParams();
const canEntry = hasPermission("Vehicle Transfer List", "entry");
  const navigate = useNavigate();
  const userId = localStorage.getItem("username");
   const [ownclosing, setOwnClosing] = useState({});
   const [branches, setBranches] = useState([]);
  const [formData, setFormData] = useState({
    toBranch: "",
  });

   // Fetch branches only once
   useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/vehicle_details_report_own")
      .then((response) => {
        setBranches(response.data.branches);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);

  
    useEffect(() => {
        const fetchOwnCLosing = async () => {
          if (!sno) return;
          try {
            Swal.fire({
                    title: "Loading Data",
                    html: `
                      <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                        <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                      </div>
                      <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch details...</p>
                    `,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                      const style = document.createElement("style");
                      style.innerHTML = `
                        @keyframes progressBar {
                          0% { width: 0% }
                          50% { width: 100% }
                          100% { width: 0% }
                        }
                      `;
                      document.head.appendChild(style);
                    },
                  });
            const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/own_vehicle_closing_details?sno=${sno}`);
            if (response.data && response.data.closingOwn?.length > 0) {
                const items = response.data.closingOwn;

                const closingOwnDetail = {
                    vcode: items[0].vehicle_code || "N/A",
                    vnumber: items[0].vehicle_number || "N/A",
                    vname: items[0].vehicle_name || "N/A",
                    vehicleBranch: items[0].branch_code || "N/A",
                    vtype: items[0].vehicle_type || "N/A",
                };

                setOwnClosing(closingOwnDetail);
            }
            Swal.close();
            
          } catch (error) {
                Swal.close();
                console.error("Error fetching branches:", error);
                Swal.fire({
                  icon: "error",
                  title: "Oops!",
                  text: "Unable to load data. Please try again.",
                });
              }
        };
    {canEntry && (
        fetchOwnCLosing()
    )}
      }, [sno]); 
    

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

   
    // Prepare payload
    const payload = {
        vcode: ownclosing.vcode,
        vehno: ownclosing.vnumber,
        vbranch: ownclosing.vehicleBranch,
        toBranch : formData.toBranch,
        vname: ownclosing.vname,
        user: userId,
        slNo: sno,

      };
      
    console.log("Submitting Payload:", payload);

    try {
      Swal.fire({
                        title: "Submitting...",
                        text: "Please wait while we process your request.",
                        allowOutsideClick: false,
                        didOpen: () => {
                          Swal.showLoading();
                        },
                      });
      const response = await axios.post(
        "https://rfs2.infraconsoft.net.in/api/change_branch_insert",
        payload
      );
         if (!response.data.success) {
                      Swal.fire({
                        icon: "error",
                        title: "Cannot Transfer",
                        text: response.data.message,
                      });
                    } else {
                      // Show success message
                      Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Vehicle Transferred Successfully.",
                        confirmButtonText: "OK",
                      }).then(() => {
                        navigate(`/vehicle_transfer_list`);
                      });
                    }
           
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Submission failed. Please try again.");
    }
  };

    if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <div className="back-div">
          <h2 className="add-txt">Change Branch</h2>
          <Link to='/vehicle_transfer_list'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="vcode" value={ownclosing.vcode} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="text" value={new Date().toLocaleDateString("en-GB")} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Name :</label>
                <input type="text" name="vname" value={ownclosing.vname} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Type :</label>
                <input type="text" name="vehno" value={ownclosing.vtype} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Current Branch :</label>
                <input type="text" name="branch" value={ownclosing.vehicleBranch} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Transfer to :</label>
                <select name="toBranch" value={formData.toBranch} onChange={handleChange} required >
            <option value="">Select Branch</option>
            {branches.map((item) => (
              <option key={item.branchMaster_code} value={item.branchMaster_code}>
                {item.branchMaster_name}
              </option>
            ))}
          </select>
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_position_entry_hire;
